import { CommonUtils } from '@infodata-group/inf-commons';

export class DaySchedule {
  public start: string;
  public end: string;

  constructor(start: string, end: string) {
    this.start = start;
    this.end = end;
  }

  public toString(): string {
    return `${this.start} - ${this.end}`;
  }

  serialize() {
    return {
      start: this.start,
      end: this.end,
    };
  }

  copy(): DaySchedule {
    return new DaySchedule(this.start, this.end);
  }

  /**
   * Check if this schedule begin after time in parameter
   * @param time in minute count (8:00 = 480)
   */
  isAfter(time: number): boolean {
    return this.getStartInMinutes() >= time;
  }

  isCompliant(): boolean {
    return this.getStartInMinutes() < this.getEndInMinutes();
  }

  getStartInMinutes() {
    const startTime = CommonUtils.convertStrToTime(this.start);
    return startTime.hours * 60 + startTime.minutes;
  }

  getEndInMinutes() {
    const endTime = CommonUtils.convertStrToTime(this.end);
    return endTime.hours * 60 + endTime.minutes;
  }

  getTotal() {
    return this.getEndInMinutes() - this.getStartInMinutes();
  }
}
